import { Component, Host, h, Prop, Element } from '@stencil/core';

@Component({
    tag: 'sew-ws-news-feed-item',
    styleUrl: 'sew-ws-news-feed-item.scss',
    shadow: true,
})
export class SewWsNewsFeedItem {
    @Element() host: HTMLSewWsNewsFeedItemElement;

    @Prop() header: string;
    @Prop() text: string;
    @Prop() video = false;

    componentWillLoad(): void {
        const anchorElement = this.host.querySelector('a, button');

        anchorElement.setAttribute('aria-label', this.text);
    }

    componentDidLoad(): void {
        const video = this.host.querySelector('sew-video');

        if (video) {
            this.host.addEventListener('mouseenter', () => {
                video.dispatchEvent(new Event('mouseenter'));
            });
            this.host.addEventListener('mouseleave', () => {
                video.dispatchEvent(new Event('mouseleave'));
            });
        }
    }

    render() {
        return (
            <Host class="splide__slide">
                <div>
                    <div class="image-wrapper">
                        <slot name="picture"></slot>
                    </div>
                    {this.header && <p>{this.header}</p>}
                    {this.video && (
                        <div class="video">
                            <sew-icon icon="play-filled" size="xl"></sew-icon>
                        </div>
                    )}
                </div>

                <p>{this.text}</p>
                <slot></slot>
            </Host>
        );
    }
}
